<template>
  <div class="code-container">
    <div class="code-text" v-if="!this.$route.query.ban">
      <p>设备激活</p>
      Equipment activation
    </div>
    <div>
      <img src="../../../images/image-active.png" alt=" " class="code-container-image" v-if="!this.$route.query.ban">
      <img src="../../../images/no-active.png" alt=" " class="code-container-image" v-else>
    </div>
    <div class="form-container" v-if="this.$route.query.ban=='false'||!this.$route.query.ban">
      <div class="code-mac">{{this.$route.query.mac.toString()}}</div>
      <van-field placeholder="请输入序列号" class="input-type" v-model.trim="code"/>
      <van-button type="primary" class="button-type" @click="activationCode">激活</van-button>
    </div>
    <div v-else class="code-msg">
      {{msg}}
    </div>
    <div class="code-jook flex">
        <div class="flex-1"></div>
        <div class="code-main" @click="codMain">设备初始化</div>
    </div>
  </div>
</template>
<script>
  import { mapActions , mapMutations , mapState } from 'vuex';
  export default {
    name: "codes",
    computed:{
      code:{
          get() { return this.$store.state.code.code },
          set(val){this.change({
              key:'code',
              value:val
          });}
      },
      ...mapState('code',['data']),
      ...mapState('device',['msg']),
    },
    methods:{
      //激活
      activationCode(){
        this.axiosData({
          data:{
            mac:this.$route.query.mac.toString()
          },
          _this:this
        });
      },
      //设备初始化
      codMain(){
        let device = sessionStorage.getItem('device');
        localStorage.clear();
        sessionStorage.clear();
        
        if(device=='windows'){
            window.location.href = `${window.location.protocol}//${window.location.host}`;
        }else{
            window.location.href = `${window.location.protocol}//${window.location.host}?mac=${this.$route.query.mac.toString()}`;
        }
      },
      ...mapMutations('code',['change']),
      ...mapActions('code',['axiosData']),
    }
  };
</script>
<style lang="scss" scoped rel="stylesheet/scss">
  @import 'code';
</style>
